import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.342 0H5.658A5.674 5.674 0 0 0 0 5.658v8.684A5.674 5.674 0 0 0 5.658 20h8.684A5.674 5.674 0 0 0 20 14.342V5.658A5.674 5.674 0 0 0 14.342 0M9.8 14.982a1.6 1.6 0 0 1-.3-.08.93.93 0 0 1-.632-.87V9.066A1.084 1.084 0 0 1 9.6 7.99a1.166 1.166 0 0 1 1.35.386.98.98 0 0 1 .2.612v2.466c0 .8-.016 1.6 0 2.4a1.134 1.134 0 0 1-1.35 1.128m.176-7.528a1.235 1.235 0 1 1 .01 0Z",
      opacity: ".598"
    }, null, -1)
  ])))
}
export default { render: render }